import { Injectable, OnDestroy } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';

import {BehaviorSubject, Subject} from 'rxjs';

@Injectable({
    providedIn: "root",
})
export class SideNavService implements OnDestroy{
    private sidenav: MatSidenav;
    sidenavData$ = new BehaviorSubject<any>(null);
    private destroy$ = new Subject<void>();
    constructor(private router: Router) {}

    public setSidenav(sidenav: MatSidenav) {
        this.sidenav = sidenav;
    }

    public close(page?) {
        const route = this.router.url.split('/');
        this.sidenavData$.next(null);
        this.sidenav.close();
        if (route && route[3] && !page){
           this.router.navigate([route[1], route[2]]);
        }
    }

    public openSidePanel(id: number): void {
        this.sidenavData$.next({ItemId: id});
        this.toggle();
    };

    public toggle(): void {
        this.sidenav.toggle();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.unsubscribe();
      }
}
